import { defaultTemplate } from 'core/hoc';
import { BaasicButton } from 'core/components';
import { PropTypes } from 'mobx-react';
import React from 'react';
import { Content } from 'core/layouts';
import { observer } from 'mobx-react';
function AdditionalValidationModalTemplate({woundOrderAddWoundDressingViewStore}){
    return(
        <Content>
            <div className="modal__eligibility__header">
                <h3 className="modal__eligibility__header--title">Check Eligibility</h3>
                <h3 className="modal__eligibility__header--subtitle">Answer a few additional questions to </h3>
            </div>
            <div className="modal__eligibility__body">
                {woundOrderAddWoundDressingViewStore.validationDressings.map(validationDressing => (
                        <div className='card--modal' key={validationDressing.validationName}>
                            <div className='card--modal__title'>
                                {validationDressing.validationName}
                            </div>
                            <div className='card--modal__item'>
                                <div className="card--modal__item--label">
                                    {validationDressing.question}
                                </div>
                                <div className="card--modal__item--list">
                                    {validationDressing.validationOptions.map(item =>
                                        <BaasicButton
                                        key={item.abrv}
                                        title={item.description}
                                        className={"btn--toggle btn--toggle--eligibility btn--base " + (validationDressing.list.includes(item.abrv) ? 'active' : '')}
                                        label={item.description}
                                        onClick={() => woundOrderAddWoundDressingViewStore.setSelectedTabItem(validationDressing.tabItemType, item.abrv, item.id, validationDressing.id, validationDressing.woundId)}
                                    />)}
                                </div>
                            </div>
                        </div>
                ))
                }      
            </div>
            <div className="modal__eligibility__footer">
                <BaasicButton
                    className='btn btn--med btn--secondary'
                    label="Cancel"
                    onClick={() => woundOrderAddWoundDressingViewStore.closeAdditionalValidationModal()}
                />
                <BaasicButton 
                    className='btn btn--med btn--secondary'
                    label="Check Eligibility"
                    onClick={() => woundOrderAddWoundDressingViewStore.submitAdditionalValidations()}
                />     
            </div>
        </Content>
    );
}

AdditionalValidationModalTemplate.propTypes = {
    woundOrderAddWoundDressingViewStore: PropTypes.object,
    t: PropTypes.func
};

export default defaultTemplate(AdditionalValidationModalTemplate);